import { ts } from '@funkey/shared';
import type { auth } from './server';
import type { I18N_CONF } from '@funkey/locales/config';
import type { db } from '@funkey/api/src';
import { ORY_POLIS_CONFIG } from '@funkey/api/src/features/auth/ory-polis/shared';

export type Auth_Tenant = Pick<typeof db.tenants.$inferSelect, 'id' | 'type' | 'slug'> & {
    /** Bizz or Partner ID */
    portalId: number;
};

export type Auth_Session = NonNullable<ReturnType<typeof _internal_auth_mapSession>>;
export function _internal_auth_mapSession(session: typeof auth.$Infer.Session | null) {
    if (session === null) return null;

    return {
        user: {
            ...session.user,
            id: Number(session.user.id),
            language: ts.cast<I18N_CONF.Language | null>()(session.user.language ?? null),
            countryCode: ts.cast<I18N_CONF.Country | null>()(session.user.countryCode ?? null),
        },
        session: {
            ...session.session,
            id: Number(session.session.id),
            userId: Number(session.session.userId),
        },
    };
}

export const GENERIC_OAUTH_PROVIDER_IDS = {
    ORY_POLIS: ORY_POLIS_CONFIG.DOMAIN,
} as const;
